module.exports = __webpack_public_path__ + "img/icon-message.1ad92180.png";